import { useEffect } from "react";

// Fallback only: the static file at /public/realitycheck/index.html is served
// directly by the web server for /realitycheck. If an environment's static
// serving hands the path to the SPA instead, forward to the real file
// (preserving ?src= tracking tags).
export default function RealityCheck() {
  useEffect(() => {
    window.location.replace("/realitycheck/index.html" + window.location.search);
  }, []);
  return null;
}
